import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAdminAuth } from "../context/AdminAuthContext";

export function ProtectedRoute({ children }) {
  const { admin } = useAdminAuth();

  if (admin === null) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center" data-testid="admin-auth-checking">
        <Loader2 className="w-6 h-6 text-[#00F0FF] animate-spin" />
      </div>
    );
  }

  if (admin === false) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}
